/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {useMemo, useState} from "react";
import {Alert, Button, Card, ProgressBar, Spinner} from "react-bootstrap";
import ApplicationPageStore from "../stores/pages/ApplicationPageStore";
import {CheckCircleFill} from "react-bootstrap-icons";
import {runInAction} from "mobx";
import WithSticky from "../pages/withs/WithSticky";
import {observer} from "mobx-react-lite";
import {ApiApplicationFormStore} from "../helpers/factory/StoreWithFormsFromData";
import {CampaignNotificationStyleVariants} from "./backoffice/configs/NotificationsConfigs";
import {PayButton} from "./PayButton";
import AxiosApiInstance, { APIBase } from "../services/api/AxiosApiInstance";
// TODO: потом понадобится
// import { PaidProvidionAgreement } from "./PaidProvidionAgreement";
// import {PaidProvidionAgreement} from "./PaidProvidionAgreement";

const ApplicationPageStickyBlock:React.FC<{
  handleApplicationSubmit: () => void;
  scrollToForm: (id: string) => void;
  applicationPageStore: ApplicationPageStore
}> = observer(({
  applicationPageStore,
  handleApplicationSubmit,
  scrollToForm,
}) => {
  const forms = applicationPageStore.model?.forms;
  const [termsAccepted, setTermsAccepted] = useState(true);
  const formsReadonly = applicationPageStore.model?.forms_readonly;
  const showSubmitButton = useMemo(() => !!applicationPageStore.model?.show_submit_button, [applicationPageStore.model?.show_submit_button]);
  // const [termsAccepted, setTermsAccepted] = useState(false);
  const docsDownloaded = useMemo(() => !!applicationPageStore.model?.docs_can_be_downloaded, [applicationPageStore.model?.docs_can_be_downloaded])

  const applicationSent = !showSubmitButton;

  const totalQuestions = applicationPageStore.model?.forms.reduce((a: number, form) => a + form.questions.length, 0) || 0;
  const totalQuestionsSubmitted = applicationPageStore.model?.forms.reduce((a: number, form) => a + form.questionsSubmitted, 0) || 0;
  const totalQuestionsMandatory = applicationPageStore.model?.forms.reduce((a: number, form) => a + form.questionsMandatory, 0) || 0;

  const overallProgress = Math.round(totalQuestionsSubmitted / totalQuestions * 100);

  const PBFormOverallProps = (form: ApiApplicationFormStore) => ({
    ...(form.fulfilled && {variant: "success"})
  });

  const PBOverallProps = {
    ...(totalQuestionsSubmitted >= totalQuestionsMandatory && {variant: "success"})
  };

  const downloadMatriculationDocs = () => {
    AxiosApiInstance.get(`${APIBase}applications/${applicationPageStore.applicationId}/matriculation_docs/`, {
      responseType: "blob"
    })
      .then((response: any) => {
        if (response.status !== 200) {
          throw new Error('Ошибка при загрузке файла');
        }
        return response.data
      })
      .then(data => {
        const link = document.createElement('a');

        const blob = new Blob([data]);
        const url = window.URL.createObjectURL(blob);
        link.href = url

        link.setAttribute('type', 'application/octet-stream');
        link.setAttribute('download', 'filename.zip');
        link.click();
      })
      .catch((e) => {
        console.log(e)
      })
  }

  console.log('store ', applicationPageStore)

  return (
    <WithSticky when={width => width >= 2048} topOffset={24} stickyClass={"sk-status-sticky"}>
      {applicationPageStore.model?.notifications.length ? applicationPageStore.model?.notifications.map((n,i) => {
        const variant = CampaignNotificationStyleVariants[n.style];

        return <Card
          key={`notification_${i}`}
          className={"mb-4"}
          {...(variant ? {
            bg: variant,
          } : {})}
          {...(variant === "danger" ? {
            text: "white",
          } : {})}
        >
          <Card.Body>
            <Card.Text>
              {n.text}
            </Card.Text>
          </Card.Body>
        </Card>;
      }) : null}

      {applicationSent ?
       applicationPageStore.model?.current_state_tag === "registration" ||
        applicationPageStore.model?.current_state_tag === "accepted" || applicationPageStore.model?.current_state_tag === "completed" ||
        applicationPageStore.model?.current_state_tag === "validated" ?
        <Card
          bg={"light"}
          text={"dark"}
          className={"mb-4"}
        >
          <Card.Body>
            {applicationPageStore.model?.show_download_docs_button ?
            (
              <>
              <Card.Title>
                Your data has been successfully verified.
              </Card.Title>
              <p>Your registration for Skoltech Digital Onboarding is now complete.</p>
              <p>Please wait for an email from the Admissions Office outlining the next steps for submitting your documents.</p>
              </>
            )
              : applicationPageStore.model?.current_state_tag === "completed" ?
              (
                <>
                <Card.Title>
                  Your profile is being verified
                </Card.Title>
                <p>This verification process typically takes up to 24 hours from the time of submission. You will receive a notification once it is completed.</p>
                </>
              )
              :
              (
                <>
                <Card.Title>
                  Your matriculation data is sent.
                </Card.Title>
                <p>Now download and sign the form.</p>
                <p>You will receive an email with detailed instructions on how to submit your signed form and other documents to the Admissions Office.</p>
                </>
              )
            }
            {applicationPageStore.model?.show_download_docs_button && <Button disabled={!docsDownloaded} onClick={downloadMatriculationDocs}>Download application</Button>}

          </Card.Body>
        </Card> : (
         <Card
         bg={"light"}
         text={"dark"}
         className={"mb-4"}
       >
         <Card.Body>
          <Card.Title>
              Your application is sent!
            </Card.Title>
            <p>Your Skoltech selection application is being processed. We will be in touch via email about next steps of the selection process. Please make sure not to miss our e-mails.</p>
            <p>At the moment you can't make any changes to the data you've provided, you can only view it.</p>
            <p>Should you have any questions, feel free to contact us at admissions@skoltech.ru. See you!</p>
         </Card.Body>
       </Card>
      ) : (
        <>
          {/** блок с прогрессом */}
          {formsReadonly?.length !== forms?.length ? <Card
            bg={"light"}
            text={"dark"}
            className={"mb-4"}
          >
            <Card.Body>
              {applicationPageStore.model?.current_state_tag === "accepted" &&
                <>
                <p>
                  Please complete your registration for Skoltech Digital Onboarding.
                </p>
                <p>
                  All mandatory fields are marked with an asterisk (*).
                </p>
              </>
              }
              <Card.Title>
                Overall application progress
              </Card.Title>
              <ProgressBar>
                <ProgressBar now={overallProgress} key={1} {...PBOverallProps}/>
              </ProgressBar>
              <div className={"d-flex align-items-baseline mt-4 mb-2"}>
                <Card.Title className={"flex-grow-1"}>
                  Progress by forms
                </Card.Title>
                <small className="text-muted">Click form name to scroll</small>
              </div>
              {forms && forms.filter(form => formsReadonly ? !formsReadonly.includes(form.id) : false).map((form: ApiApplicationFormStore) => (
                <div className={"d-flex align-items-baseline mb-0"} key={form.id}>
                  <h6 className={"w-50 mr-4"}>
                    <a href="#" onClick={(e: React.MouseEvent) => {
                      e.preventDefault();
                      scrollToForm(form.id);
                    }}
                    className={`${form.fulfilled && "text-success"}`}
                    >
                      {form.name} {form.fulfilled && <CheckCircleFill className={"ml-2 align-middle"}/>}
                    </a>
                  </h6>
                  <div className={"w-50"}>
                    <ProgressBar className={"mb-4"}>
                      {form.name === 'Profile' && <ProgressBar now={Math.round(form.questionsSubmitted / (form.questions.length - 1) * 100)} key={1} {...PBFormOverallProps(form)}/>}
                      {form.name === 'Education details' && <ProgressBar now={Math.round(form.questionsSubmitted / (form.questions.length - 2) * 100)} key={1} {...PBFormOverallProps(form)}/>}
                      {form.name === 'Professional details' && <ProgressBar now={Math.round(form.questionsSubmitted / (form.questions.length - 13) * 100)} key={1} {...PBFormOverallProps(form)}/>}
                      {form.name === 'Digital onboarding' && <ProgressBar now={Math.round(form.questionsSubmitted / (form.questions.filter(q => !(q.dependency as []).length).length) * 100)} key={1} {...PBFormOverallProps(form)}/>}
                    </ProgressBar>
                  </div>
                </div>
              ))}
            </Card.Body>
          </Card> : null}

          {showSubmitButton ? <>
            {applicationPageStore.model?.can_be_submitted && (totalQuestionsSubmitted >= totalQuestionsMandatory) && (
              <p className={"lead"}>
                You've filled out all the mandatory fields. Next, you can pay the application fee and submit your application.
              </p>
            )}
            {applicationPageStore.model?.show_pay_button && (totalQuestionsSubmitted >= totalQuestionsMandatory) && (
              <p className={"lead"}>
                Please proceed with a processing fee payment.
              </p>
            )}
            {applicationPageStore.submitError && <Alert
              variant="danger"
              onClose={() => runInAction(() => {
                applicationPageStore.submitError = "";
              })}
              dismissible
            >
              {applicationPageStore.submitError}
            </Alert>}
            {!applicationPageStore.model?.show_pay_button && (<>
              {/* <Button className={"mt-4 mb-4"} variant={"primary"} size={"lg"} block disabled={!termsAccepted || !applicationPageStore.model?.can_be_submitted} onClick={handleApplicationSubmit}>
                {applicationPageStore.state === "submit"
                    ? <><Spinner
                        as="span"
                        animation="border"
                        role="status"
                        aria-hidden="true"
                    /></>
                    : <>Submit Application</>
                }
              </Button> */}
              <Button className={"mt-4 mb-4"} variant={"primary"} size={"lg"} block disabled={!applicationPageStore.model?.can_be_submitted} onClick={handleApplicationSubmit}>
                {applicationPageStore.state === "submit"
                    ? <><Spinner
                        as="span"
                        animation="border"
                        role="status"
                        aria-hidden="true"
                    /></>
                    : <>Submit</>
                }
              </Button>
              {/* <PaidProvidionAgreement termsAccepted={termsAccepted} setTermsAccepted={setTermsAccepted}/> */}
            </>)}
            {applicationPageStore.model?.show_pay_button && !!applicationPageStore.model?.pay_button_url_robokassa && (
              <PayButton url={applicationPageStore.model?.pay_button_url_robokassa} caption={`Pay ${applicationPageStore.model?.payment_amount} RUB`} termsAccepted={termsAccepted} variant="primary"/>
            )}
            {applicationPageStore.model?.show_pay_button && !!applicationPageStore.model.pay_button_url_robokassa_international && (
              <PayButton url={applicationPageStore.model?.pay_button_url_robokassa_international} caption={`Pay $${applicationPageStore.model?.payment_amount_usd} / ${applicationPageStore.model?.payment_amount_usd_in_rub} RUB`} termsAccepted={termsAccepted} variant="info"/>
            )}
              {/* <PaidProvidionAgreement termsAccepted={termsAccepted} setTermsAccepted={setTermsAccepted}/> */}
          </> : null}
        </>
      )}
    </WithSticky>
  );
});

export default ApplicationPageStickyBlock;
